import { DISPLAYMODE } from "./SearchToolbar/DisplayMode";
import { CONTENT_TYPES } from "./searchConstants";

/**
 * Sorts an array of search results alphabetically by title/name
 */
export const sortCuratedListingAlpha = (array) => {
  return array.sort((a, b) => {
    let aCompare = "";
    let bCompare = "";
    
    if (a.contentType === CONTENT_TYPES.PRODUCT) {
      aCompare = a.childProductName;
    } else if (a.contentType === CONTENT_TYPES.PRODUCT_FAMILY) {
      aCompare = a.promoTitle;
    } else if (a.title) {
      aCompare = a.title;
    }
    
    if (b.contentType === CONTENT_TYPES.PRODUCT) {
      bCompare = b.childProductName;
    } else if (b.contentType === CONTENT_TYPES.PRODUCT_FAMILY) {
      bCompare = b.promoTitle;
    } else if (b.title) {
      bCompare = b.title;
    }
    
    if (aCompare && bCompare) {
      return aCompare.localeCompare(bCompare);
    } else {
      return aCompare;
    }
  });
};

/**
 * Calculates total count of all refinement categories
 */
export const totalSearchItemsCount = (counts, gotRefinements) => {
  if (gotRefinements === true && counts) {
    return counts.reduce((totalCount, category) => {
      const total = totalCount + category.count;
      return total;
    }, 0);
  }
  return null;
};

/**
 * Gets default desktop toggle values from global properties
 */
export const defaultDesktopToggleValues = () => {
  let defaultValues = [];
  if (window.globalProperties && window.globalProperties.toggleFacetGroups) {
    window.globalProperties.toggleFacetGroups.forEach((tfg) => {
      defaultValues.push(tfg.option1ToggleLabel);
    });
  }
  return defaultValues;
};

/**
 * Positions a modal card for hover effect
 */
export const positionModal = (cardRef, externalModalDiv, displayMode, isHovered, isModalHovered) => {
  if (
    displayMode === DISPLAYMODE.GRIDCOMPACT &&
    externalModalDiv &&
    (isHovered || isModalHovered) &&
    cardRef.current
  ) {
    // Ensure modal is visible before measuring
    externalModalDiv.style.display = "block";

    // Defer positioning to next animation frame for correct layout
    window.requestAnimationFrame(() => {
      const rect = cardRef.current.getBoundingClientRect();
      const width = rect.width;
      const top = rect.top;
      const left = rect.left;

      externalModalDiv.style.position = "fixed";
      externalModalDiv.style.top = `${top}px`;
      externalModalDiv.style.left = `${left}px`;
      externalModalDiv.style.width = `${width}px`;
      externalModalDiv.style.zIndex = 6;
      externalModalDiv.style.margin = "0";
      externalModalDiv.style.padding = "0";

      const cardStyle = window.getComputedStyle(cardRef.current);
      externalModalDiv.style.backgroundColor = cardStyle.backgroundColor;
      externalModalDiv.style.border = "none";
      externalModalDiv.style.borderRadius = `0 0 ${cardStyle.borderBottomRightRadius} ${cardStyle.borderBottomLeftRadius}`;
      externalModalDiv.style.borderTop = "none";

      externalModalDiv.classList.add("modal-visible");
    });
  } else if (externalModalDiv) {
    externalModalDiv.style.backgroundColor = "";
    externalModalDiv.style.border = "";
    externalModalDiv.style.borderRadius = "";
    externalModalDiv.classList.remove("modal-visible");
    externalModalDiv.style.display = "";
  }
};

/**
 * Determines search content type from string
 */
export const getSearchContentType = (contentTypeString) => {
  switch (contentTypeString) {
    case "Products":
      return CONTENT_TYPES.PRODUCT;
    case "Articles":
      return CONTENT_TYPES.ARTICLE;
    case "PDFs":
      return CONTENT_TYPES.DOCUMENT;
    case "Webpages":
      return CONTENT_TYPES.WEBPAGE;
    case "Media Collections":
      return CONTENT_TYPES.MEDIA;
    default:
      return CONTENT_TYPES.MEDIA;
  }
};
